import { render, staticRenderFns } from "./notification-popup.vue?vue&type=template&id=94a575c6&scoped=true&"
import script from "./notification-popup.vue?vue&type=script&lang=js&"
export * from "./notification-popup.vue?vue&type=script&lang=js&"
import style0 from "./notification-popup.vue?vue&type=style&index=0&id=94a575c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a575c6",
  null
  
)

export default component.exports